import { useEffect, useState } from 'react'
import { useUser } from '@fs/zion-user'
import { getStoriesFromCisId } from '../../services/MemoriesAPI/memoriesAPI'

export default function useGalleryStories() {
  const [stories, setStories] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const { cisId } = useUser()

  useEffect(() => {
    const fetchStories = async () => {
      setLoading(true)
      setError(null)
      try {
        const { data } = await getStoriesFromCisId(cisId)
        setStories(data?.artifact || [])
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    if (cisId) fetchStories()
  }, [cisId])

  return { stories, loading, error }
}
